module.exports = __webpack_public_path__ + "static/media/st-2.0d34c38c.jpg";